import { Routes } from '@angular/router';
import { CampaignListComponent } from './campaign-list/campaign-list.component';
import { CampaignComponent } from './campaign/campaign.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './auth.guard';
import { DealViewComponent } from './deal-view/deal-view.component';
import { DealListComponent } from './deal-list/deal-list.component';
import { PaymentListComponent } from './payment-list/payment-list.component';
import { NotificationJobsListComponent } from './notification-jobs-list/notification-jobs-list.component';
import { DealsWithOverduesComponent } from './deals-with-overdues/deals-with-overdues.component';
import { AutoRenewalDealsComponent } from './auto-renewal-deals/auto-renewal-deals.component';
import { CustomerAccountingListComponent } from './customer-accounting-list/customer-accounting-list.component';
import { CustomerAccountingTabComponent } from './customer-accounting-tab/customer-accounting-tab.component';

export const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'campaigns', component: CampaignListComponent, canActivate: [AuthGuard], data: { roles: ['CampaignManager'] } },
    { path: 'campaign/add', component: CampaignComponent, canActivate: [AuthGuard], data: { roles: ['CampaignManager'] } },
    { path: 'campaign/edit/:id', component: CampaignComponent, canActivate: [AuthGuard], data: { roles: ['CampaignManager'] } },

    // deals
    { path: 'deals/overdues', component: DealListComponent, canActivate: [AuthGuard], data: { roles: ['DealManager'] } },
    { path: 'deals/renewals', component: AutoRenewalDealsComponent, canActivate: [AuthGuard], data: { roles: ['DealManager'] } },
    { path: 'deals/payments', component: PaymentListComponent, canActivate: [AuthGuard], data: { roles: ['AccountingManager', 'DealManager'] } },
    { path: 'deals/overdue-payments', component: DealsWithOverduesComponent, canActivate: [AuthGuard], data: { roles: ['DealManager'] } },
    { path: 'deals/edit/:id', component: DealViewComponent, canActivate: [AuthGuard], data: { roles: ['AccountingManager', 'DealManager'] } },

    // notifications
    { path: 'notifications/upcoming', component: NotificationJobsListComponent, canActivate: [AuthGuard], data: { roles: ['DealManager'] } },

    // accounting
    { path: 'accounting/tabs', component: CustomerAccountingListComponent, canActivate: [AuthGuard], data: { roles: ['AccountingManager'] } },
    { path: 'accounting/tabs/:id', component: CustomerAccountingTabComponent, canActivate: [AuthGuard], data: { roles: ['AccountingManager'] } },

];
